import {
  GET_LOOKUP_DOCUMENT_TYPE_OK,
  GET_LOOKUP_DOCUMENT_TYPE_ERR,
} from "./lookup-document-type.action.js";

const InitState = {
  error: null,
  content: null,
};

export default function LookupDocumentTypeReducer(state = InitState, action) {
  switch (action.type) {
    case GET_LOOKUP_DOCUMENT_TYPE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_LOOKUP_DOCUMENT_TYPE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
